import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Button, Checkbox, Divider, Grid, Input, InputLabel, Paper, TextField, Typography } from '@mui/material'

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import karmaStyles from '../../styles/KarmaPool.module.css'
import CauseCardComponent from './causes/CauseCardComponent';
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';
import DashboardBackButtonComponent from './footer/DashboardBackButtonComponent';
import { Link } from 'react-router-dom';



function DashboardFAQComponent(props) {

    const theme = useTheme();
    const isMediumScreenSize = useMediaQuery(theme.breakpoints.up('sm'));

    const karmaContext = useKarmaPoolContext();

    const [gbpFor20Tokens, setGbpFor20Tokens] = useState(0.0);
    const [memberSlots, setMemberSlots] = useState(25);

    useEffect(() => {

        let donationAmount = props.donationAmount === undefined ? 0 : props.donationAmount;

        if (karmaContext.local.cycle != null) {
            setGbpFor20Tokens(((karmaContext.local.cycle.gbpInCycle * 1.0 + (donationAmount / 4.0)) / (karmaContext.local.cycle.totalTokensAllocated + 20)) * 20);
        }

        if (karmaContext.local.pool != null) {
            setMemberSlots(karmaContext.local.pool.memberSlots);
        }
    }, []);

    useEffect(() => {
        
        let donationAmount = props.donationAmount === undefined ? 0 : props.donationAmount;

        if (karmaContext.local.cycle != null) {
            setGbpFor20Tokens(((karmaContext.local.cycle.gbpInCycle * 1.0 + (donationAmount / 4.0)) / (karmaContext.local.cycle.totalTokensAllocated + 20)) * 20);
        }
    }, [props.donationAmount]);

    const [faqSection, setFaqSection] = useState("general");

    function ChangeSelected(selected) {
        setFaqSection(selected);
    }

    return (
        <>
            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                <Typography variant="h5" sx={{ color: "whitesmoke" }}>
                    FAQ
                </Typography>
                <Paper sx={{ marginBottom: "1.0rem" }} />
                <Link href="#" onClick={(event) => ChangeSelected("general")}>
                    {faqSection === "general" ? <strong>General </strong> : "General "}
                </Link>
                /
                {" "}
                <Link href="#" onClick={(event) => ChangeSelected("membership")}>
                    {faqSection === "membership" ? <strong>Membership </strong> : "Membership"}
                </Link>
                {" "}
                /
                {" "}
                <Link href="#" onClick={(event) => ChangeSelected("future")}>
                    {faqSection === "future" ? <strong>Future </strong> : "Future"}
                </Link>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Divider sx={{ marginTop: "0.75rem", marginBottom: "0.125rem", backgroundColor: "whitesmoke", width: "16rem" }} />
                </Box>
                {
                    RenderFAQ()
                }
            </Typography>
        </>
    );

    function RenderFAQ() {
        switch (faqSection) {
            case "general":
                return RenderGeneralFAQ();
            case "membership":
                return RenderMembershipFAQ();
            case "future":
                return RenderFutureFAQ();
            default:
                return RenderGeneralFAQ();
        }
    }



    function RenderGeneralFAQ() {
        return (
            <>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) What is the Karma Pool?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                Think of the Karma Pool as a communal pot dedicated to doing good things. Our members have the power to decide where our efforts go.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) What is Karmatic?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                Karmatic is the social enterprise behind the Karma Pool. We make Exp Minima and run Dance Karma too.
                                
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) How much will I direct the giving?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                Right now, you could direct £{gbpFor20Tokens.toFixed(2)} to the good causes you care about for as little as £1 a month.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) Could that amount change?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                            When everyone casts their vote, the impact of each individual is diluted in the bigger pool. Use your tokens, vote, and target the causes that need it most! 🗳️✨
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) What charities are supported?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                There are charities that focus on direct giving to those in extreme poverty, climate change, critical medical aid and animal welfare. Members will have a say in future good causes.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Paper sx={{ marginBottom: "1.5rem" }} />
            </>
        );
    }

    // Render the FAQ for the Membership

    function RenderMembershipFAQ() {
        return (
            <>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) Where does my membership fee go?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                            £1 of your membership supports Karmatic's vision and growth. The remaining portion is a pure donation to the causes we support.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Paper sx={{ marginBottom: "1.5rem" }} />
            </>
        );
    }

    // Render the FAQ for the Membership

    function RenderFutureFAQ() {
        return (
            <>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) How long will this run?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                As long as it can. The vision is to build something sustainable.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) How will the Karma Pool be built?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                By many small iterations.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Paper sx={{ marginBottom: "1.5rem" }} />
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Paper sx={{ marginBottom: "0.5rem" }} />
                    <Box sx={{
                        width: "47.5%", maxWidth: "18rem",
                        minWidth: "18rem", padding: "0.0rem",
                    }}>
                        <Box sx={{ marginTop: "0.0rem" }}>
                            <strong>(Q) Is there a long-term vision?</strong>
                            {/* on click, button should open /karma/dashboard/newsletter */}
                            <Paper sx={{ marginBottom: "0.25rem" }} />
                            <Typography variant="body2" sx={{ color: "whitesmoke" }}>
                                An eco system that amplifies positive impact.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </>
        );
    }
}

export default DashboardFAQComponent;